import {abstractMethod} from './util.es6.js';

export class Reality {

	getReality() { abstractMethod('Reality', 'getReality') }

}



/** WEBPACK FOOTER **
 ** ./src/Reality.es6.js
 **/